/** Persist last-touch affiliate ref from URL (?ref= or ?aff=) for activity logging. */
export const AFFILIATE_REF_STORAGE_KEY = "coupondealz_affiliate_code";

export function sanitizeAffiliateRef(raw) {
  return String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]/g, "")
    .slice(0, 64);
}

export function captureAffiliateRefFromSearch(search) {
  if (typeof window === "undefined") return;
  try {
    const q = new URLSearchParams(
      search && search.startsWith("?") ? search.slice(1) : search || ""
    );
    const raw = q.get("ref") || q.get("aff") || q.get("affiliate");
    const code = sanitizeAffiliateRef(raw);
    if (code) {
      window.sessionStorage.setItem(AFFILIATE_REF_STORAGE_KEY, code);
    }
  } catch {
    /* ignore */
  }
}

export function readAffiliateRefForActivity() {
  try {
    return sanitizeAffiliateRef(window.sessionStorage.getItem(AFFILIATE_REF_STORAGE_KEY));
  } catch {
    return "";
  }
}
